const green = {
  100: '#14C510'
};

export { green };
